module.exports = __webpack_public_path__ + "img/hungaria-bottle.6a2e1c97.png";